
import novaSolicitacaoRegraRoutes from './novaSolicitacao/rotas.js';

const routes = [
    {
        path: 'regras',
        name: 'CadastroRegras',
        component: () => import('./Listagem.vue'),
        children: [
            {
                path: ':id',
                name: 'DetalhesRegras',
                component: () => import('./DetalheRegras/DetalhesRegras.vue'),
                meta: {
                    rules: [''],
                },
            },
            ...novaSolicitacaoRegraRoutes
        ],
        meta: {
            rules: ['ANALISTA', 'GERENTE'],
            requiredUnidade: 'UNIDADE DE GESTÃO DE PESSOAS'
        },
    },

];
export default routes;
